export const GET_AREAS_FETCHING = 'GET_AREAS_FETCHING'
export const GET_AREAS_SUCCESS = 'GET_AREAS_SUCCESS '
export const GET_AREAS_FAILURE = 'GET_AREAS_FAILURE'

export const SET_AREAS_SUCCESS = 'SET_AREAS_SUCCESS'
